import React, { useState } from 'react';
import { db } from '../firebase';
import { doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { FaTrash, FaCheck, FaPhone, FaEnvelope } from 'react-icons/fa';

function AdminConsultations({ consultations, onUpdate }) {
  const [filter, setFilter] = useState('all');

  const handleStatusChange = async (id, newStatus) => {
    try {
      await updateDoc(doc(db, 'consultations', id), { status: newStatus });
      onUpdate();
    } catch (error) {
      alert('Ошибка обновления статуса: ' + error.message);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Удалить обращение?')) {
      try {
        await deleteDoc(doc(db, 'consultations', id));
        onUpdate();
      } catch (error) {
        alert('Ошибка удаления: ' + error.message);
      }
    }
  };

  const filteredConsultations = consultations.filter(c => 
    filter === 'all' || c.status === filter
  );

  return (
    <div className="admin-consultations">
      <div className="page-header">
        <h2>Заявки на консультацию</h2>
        <div className="filters-bar">
          <select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="all">Все заявки</option>
            <option value="new">Новые</option>
            <option value="processed">Обработанные</option>
          </select>
        </div>
      </div>

      <div className="consultations-list">
        {filteredConsultations.length === 0 ? (
          <div className="empty-state">
            <p>Нет заявок</p>
          </div>
        ) : (
          filteredConsultations.map(consultation => (
            <div key={consultation.id} className={`consultation-card ${consultation.status}`}>
              <div className="consultation-header">
                <div>
                  <h3>{consultation.name}</h3>
                  <span className={`status-badge ${consultation.status}`}>
                    {consultation.status === 'new' ? 'Новая' : 'Обработана'}
                  </span>
                </div>
                <div className="consultation-date">
                  {new Date(consultation.createdAt).toLocaleString('ru-RU')}
                </div>
              </div>
              
              <div className="consultation-body">
                <div className="contact-info">
                  <p><FaPhone /> {consultation.phone}</p>
                </div>
                {consultation.question && (
                  <div className="question-text">
                    <strong>Вопрос:</strong>
                    <p>{consultation.question}</p>
                  </div>
                )}
              </div>

              <div className="consultation-actions">
                {consultation.status === 'new' && (
                  <button 
                    className="btn-success"
                    onClick={() => handleStatusChange(consultation.id, 'processed')}
                  >
                    <FaCheck /> Обработано
                  </button>
                )}
                {consultation.status === 'processed' && (
                  <button 
                    className="btn-secondary"
                    onClick={() => handleStatusChange(consultation.id, 'new')}
                  >
                    Вернуть в новые
                  </button>
                )}
                <button 
                  className="btn-delete"
                  onClick={() => handleDelete(consultation.id)}
                >
                  <FaTrash /> Удалить
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default AdminConsultations;
